import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { MsalService, MsalBroadcastService } from '@azure/msal-angular';
import { EventMessage, AuthenticationResult,EventType } from '@azure/msal-browser';
import { filter } from 'rxjs/operators';
import { GlobalService } from './global.service';

@Injectable({
  providedIn: 'root'
})
export class AuthService {
  // msalBroadcastService: any;
  // msalInstance: any;
  // global: any;

  constructor(private myRoute: Router, private msalInstance: MsalService,
    private msalBroadcastService: MsalBroadcastService, 
    private global: GlobalService, ) { }
  sendToken(token: string) {
    localStorage.setItem("LoggedInUser", token)
  }
  getToken() {
    return localStorage.getItem("LoggedInUser")
  }
  getName(): string {
    return this.msalInstance.instance.getActiveAccount().username
  }
  isLoggednIn() {
    return this.getToken() !== null;
  }
  logout() {
    /*localStorage.removeItem("LoggedInUser");
    this.myRoute.navigate(["login"]);*/
    localStorage.setItem('isLoggedIn','false');    
    localStorage.removeItem("SapId");
    localStorage.removeItem("Onbehalf");
  }

  sendToLoginRedirect() {

    const loginRequest = {
      scopes: ['api://f5525f4e-b54b-4db3-8a3d-a3160fecdbed/access_as_user']
    };


    this.msalBroadcastService.msalSubject$
      .pipe(filter((msg: EventMessage) => msg.eventType === EventType.LOGIN_SUCCESS || msg.eventType === EventType.ACQUIRE_TOKEN_SUCCESS))
      .subscribe((result: EventMessage) => {

        //console.log('Login Success!', result.payload);
       
      });

    this.msalBroadcastService.msalSubject$
      .pipe(filter((msg: EventMessage) => msg.eventType === EventType.LOGIN_FAILURE),)
      .subscribe((error: EventMessage) => {
        //console.log('Login Fails!', error);
      });

    this.msalInstance.instance.acquireTokenSilent(loginRequest).then(tokenResponse => {
      localStorage.clear();
      sessionStorage.clear();
      if (tokenResponse) {
        //console.log('Inside acquireTokenSilent', tokenResponse);
        localStorage.clear();
        sessionStorage.clear();
        sessionStorage.setItem('ADAccessToken', tokenResponse.accessToken);
        this.global.IsUserLoggedIn = true;
        this.myRoute.navigate(['home']);
      }
    }).catch(error => {
      //console.log('acquireTokenSilent -Error ------------', error);
      this.msalInstance.instance.loginRedirect(loginRequest);
    })

    this.msalInstance.handleRedirectObservable().subscribe((res: AuthenticationResult) => {
      if (res) {
        // additional checks will be added here
        this.msalInstance.instance.setActiveAccount(res.account);
        //console.log(res);
        this.myRoute.navigate(['home']);
      }
    }, error => console.error('Redirect Success: ', error));
  }
  
}
